import { SETTINGS } from "../settings";
import { DirectionsResultsDisplayer } from "../stores-js/ui/directionsresultsdisplayer";
import {
    createWoosmapDirectionsProvider as _createWoosmapDirectionsProvider,
    cleanMapFromRoutes,
    getPaddingForWindow,
    selectRouteByIndexInPanel,
} from "../utils/global";
import SERVICE_REGISTRY from "./registry";
let woosmapDirectionsProvider = null;
let woosmapDirectionsResultsDisplayer = null;
const directionsService = new woosmap.map.DirectionsService();
const directionsRenderer = new woosmap.map.DirectionsRenderer({});
const transitService = new woosmap.map.TransitService();
const transitRenderer = new woosmap.map.TransitRenderer({});

let originLocation = null;
let destinationLocation = null;
const directionOptions = {
    avoidHighways: false,
    avoidTolls: false,
    avoidFerries: false,
};

function handleDirectionsProviderError() {
    console.log("No direction found");
}

function directionsRenderersChanged() {
    const summary = woosmapDirectionsProvider.get("directionsSummaries")[0];
    const renderer = woosmapDirectionsProvider.get("directionsRenderers")[0];

    // convert string distance and durtation to number
    const distance = Number.parseFloat(summary.distance.replace(" km", "").replace(",", "")) * 1000;
    let duration = 0;

    if (summary.durationShort.indexOf("h") >= 0) {
        duration +=
            Number.parseFloat(summary.durationShort.replace(" ", "").split("h")[0]) * 3600 +
            Number.parseFloat(summary.durationShort.replace(" ", "").split("h")[1].replace("min", "")) * 60;
    } else {
        duration += Number.parseFloat(summary.durationShort.replace(" ", "").replace("min", "")) * 60;
    }
    if (renderer && SETTINGS.isSearchAlongTheRouteActive) {
        const route = renderer.directions.routes[0].overview_path;
        const rawPolyline = route.map((latlng) => new woosmap.map.LatLng(latlng.lng(), latlng.lat()));
        SERVICE_REGISTRY.storeService.setPolylineFilter(
            rawPolyline,
            originLocation,
            destinationLocation,
            distance,
            duration,
        );
    }
}

function updateOriginDestination() {
    if (originLocation && destinationLocation) {
        woosmapDirectionsProvider.set("originDestination", {
            origin: `${originLocation.lng},${originLocation.lat}`,
            destination: `${destinationLocation.lng},${destinationLocation.lat}`,
        });
        // woosmapDirectionsProvider.set('originDestination', {
        //   origin: { lat: originLocation.lat, lng: originLocation.lng },
        //   destination: { lat: destinationLocation.lat, lng: destinationLocation.lng },
        // });
    } else {
        // woosmapDirectionsResultsDisplayer.cleanMapFromRoutes();
        if (SETTINGS.isSearchAlongTheRouteActive) {
            cleanMapFromRoutes(woosmapDirectionsProvider);
            SERVICE_REGISTRY.storeService.resetPolylineFilter();
            SERVICE_REGISTRY.storeService.resetStores();
        }
    }
}

function createWoosmapDirectionsProvider() {
    // woosmapDirectionsProvider = new woosmap.location.DirectionsProvider(SETTINGS.itinaryRendererOptions, directionOptions, handleDirectionsProviderError);
    woosmapDirectionsProvider = _createWoosmapDirectionsProvider(SETTINGS.itinaryRendererOptions, directionOptions);

    woosmapDirectionsProvider.selectedTravelMode = "DRIVING";

    if (woosmapDirectionsResultsDisplayer.get("directionsRenderers")) cleanMapFromRoutes(woosmapDirectionsProvider);
    woosmapDirectionsResultsDisplayer.unbindAll();
    woosmapDirectionsResultsDisplayer.bindTo("directionsRenderers", woosmapDirectionsProvider);
    woosmapDirectionsResultsDisplayer.bindTo("directionsSummaries", woosmapDirectionsProvider);

    woosmapDirectionsProvider.directionsRenderers_changed = directionsRenderersChanged;

    updateOriginDestination();
}

function init(mapView) {
    this.mapView = mapView;
    woosmapDirectionsResultsDisplayer = new DirectionsResultsDisplayer(mapView.map, "", () => {
        const computedDirections = woosmapDirectionsResultsDisplayer.get("directionsRenderers")[0].directions;
        const bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(computedDirections.routes[0].bounds.southwest),
            new google.maps.LatLng(computedDirections.routes[0].bounds.northeast),
        );
        mapView.map.fitBounds(bounds, getPaddingForWindow());
    });

    createWoosmapDirectionsProvider();
}

const itinaryService = {
    init,
    setOrigin(origin) {
        originLocation = origin;
        updateOriginDestination();
    },
    setDestination(destination) {
        destinationLocation = destination;
        updateOriginDestination();
    },
    updateOptions(avoidHighways, avoidTolls, avoidFerries) {
        directionOptions.avoidHighways = avoidHighways;
        directionOptions.avoidTolls = avoidTolls;
        directionOptions.avoidFerries = avoidFerries;
        createWoosmapDirectionsProvider();
    },
    getOptions() {
        return directionOptions;
    },
    setRouteOptions(options) {
        directionOptions.avoidHighways = options.avoidHighways;
        directionOptions.avoidTolls = options.avoidTolls;
        directionOptions.avoidFerries = options.avoidFerries;
    },
    setStartDatetime(date) {
        if (date) {
            directionOptions.drivingOptions = {
                departureTime: date,
            };
            SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = false;
            updateOriginDestination();
        } else if (directionOptions.drivingOptions) {
            directionOptions.drivingOptions = undefined;
            if (!SETTINGS.isSearchAlongTheRouteActive) {
                SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            }
            updateOriginDestination();
        }
    },
    reverseOriginDestination() {
        const temp = originLocation;
        originLocation = destinationLocation;
        destinationLocation = temp;
        updateOriginDestination();
    },
    getDestination() {
        return destinationLocation;
    },
    getOrigin() {
        return originLocation;
    },
    getWoosmapDirections(request, callback) {
        const originArr = request.origin.split(",");
        const destArr = request.destination.split(",");
        if (request.travelMode === "transit") {
            this.getWoosTransitDirections(request, callback);
        } else {
            if (transitRenderer) {
                transitRenderer.setMap(null);
            }
            directionsRenderer.setMap(this.mapView.map);
            let routeRequest = {
                origin: {
                    lat: originArr[1],
                    lng: originArr[0],
                },
                destination: {
                    lat: destArr[1],
                    lng: destArr[0],
                },
                travelMode: request.travelMode,
                provideRouteAlternatives: SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives,
                details: "full",
                language: SETTINGS.googleDirectionsRequestOptions.language,
            };
            routeRequest = {
                ...routeRequest,
                ...directionOptions,
            };
            if (directionOptions.drivingOptions) {
                routeRequest = {
                    ...routeRequest,
                    ...{
                        departure_time: directionOptions.drivingOptions?.departureTime
                            ? directionOptions.drivingOptions?.departureTime
                            : "now",
                    },
                };
            }
            directionsService.route(routeRequest, (response, status) => {
                if (status === "OK") {
                    directionsRenderer.setDirections(response);
                    directionsRenderer.addListener("routeIndex_changed", () => {
                        selectRouteByIndexInPanel(directionsRenderer.get("routeIndex"));
                    });
                    callback(response, status, directionsRenderer);
                } else {
                    callback(response, status, null);
                    // window.alert(`Directions request failed due to ${status}`);
                }
            });
        }
    },
    getWoosTransitDirections(request, callback) {
        const originArr = request.origin.split(",");
        const destArr = request.destination.split(",");
        if (directionsRenderer) {
            directionsRenderer.setMap(null);
        }
        transitRenderer.setMap(this.mapView.map);
        transitService
            .route({
                origin: {
                    lat: originArr[1],
                    lng: originArr[0],
                },
                destination: {
                    lat: destArr[1],
                    lng: destArr[0],
                },
            })
            .then((response) => {
                if (response.status === "OK") {
                    transitRenderer.setRoutes(response.routes);
                    callback(response, response.status, transitRenderer);
                } else {
                    callback(response, response.status, null);
                }
            })
            .catch((error) => {
                console.error("Error calculating transit route:", error);
            });
    },
};

export default itinaryService;
